import * as React from 'react';
import cancelIcon from '../../../assets/img/cancelIcon.svg';
import checkIcon from '../../../assets/img/checkIcon.svg';
import timeout from '../../../assets/img/Login/timeout.svg';
import Modal, { ModalBody } from '../Modal';
import { useClickAway } from '@uidotdev/usehooks';
export default function Notifications({
    open,
    title,
    success,
    onClose,
    isSession,
    description,
}: {
    open: boolean;
    onClose?: any;
    title: string;
    success: boolean;
    isSession?: boolean;
    description?: any;
}): React.JSX.Element {
    const ref = useClickAway<any>(() => {
        onClose();
    });
    React.useEffect(() => {
        let timer: NodeJS.Timeout;
        if (open) {
            timer = setTimeout(() => {
                onClose();
            }, 3000);
        }
        return () => clearTimeout(timer);
    }, [open, onClose]);
    return (
        <Modal open={open} id={'notification-modal'} expandModal={false}>
            <ModalBody expandModal={false}>
                <div
                    ref={ref}
                    className="py-14 overflow-y-auto mx-[2.5rem] z-50"
                    data-testid="notifications"
                >
                    {isSession ? (
                        <div className="flex flex-col space-y-3 ">
                            <div className="border-b-2 border-primary-700 flex space-x-2 justify-center items-center p-2">
                                <img src={timeout} alt="timeout" />
                                <label
                                    htmlFor="hs-validation-name-error"
                                    className="block text-xl text-[#394148] font-medium mb-2"
                                >
                                    {title}
                                </label>
                            </div>
                            <div className="">
                                <label
                                    htmlFor="hs-validation-name-error"
                                    className="block text-sm text-[#394148] font-light mb-2"
                                >
                                    {description}
                                </label>
                            </div>
                        </div>
                    ) : (
                        <div className="flex">
                            <div className="mr-2">
                                {success ? (
                                    <img src={checkIcon} alt="Success" />
                                ) : (
                                    <img src={cancelIcon} alt="Error" />
                                )}
                            </div>
                            <div>
                                <label
                                    htmlFor="hs-validation-name-error"
                                    className="block text-xl text-[#394148] font-medium mb-2"
                                >
                                    {title}
                                </label>
                            </div>
                        </div>
                    )}
                </div>
            </ModalBody>
        </Modal>
    );
}
